export default "__VITE_ASSET__CXmtsf_$__"